class VideoSlider extends HTMLElement {
    constructor() {
        super();
        this.elements = {
            slider_element: this
        }
        this.init();
    }

    connectedCallback() {
        if (Shopify.designMode) {
            this.onShopifySectionLoad = this.onSectionLoad.bind(this);
            this.onShopifySectionSelect = this.onSectionSelect.bind(this);
            this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
            document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
            document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
            document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
        }
    }

    disconnectedCallback() {
        if (Shopify.designMode) {
            document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
            document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
            document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
        }
    }

    onSectionLoad(event) {
        filterShopifyEvent(event, this, () => this.initSlider.bind(this));
    }
    onSectionSelect(event) {
        filterShopifyEvent(event, this, this.initSlider.bind(this));
    }
    onSectionDeselect(event) {
        filterShopifyEvent(event, this, this.initSlider.bind(this));
    }


    init() {
        if (Shopify && Shopify.designMode) {
            this.initSlider();
        }
        setTimeout(() => {
            this.initSlider();
        })
    }


    initSlider() {
        var swiper = new Swiper(this.elements.slider_element, {
            spaceBetween: 80,
            navigation: {
                nextEl: ".swiper-button-next-video",
                prevEl: ".swiper-button-prev-video"
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }
}
customElements.define('video-slider', VideoSlider);
